import { render, staticRenderFns } from "./GmoDeferredStatus.pug?vue&type=template&id=70c03bf1&lang=pug&"
import script from "./GmoDeferredStatus.vue?vue&type=script&lang=js&"
export * from "./GmoDeferredStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports